import React from 'react';

export const EqMoreInfoModal = {
  title: 'Additional Earthquake Information',
  body: (
    <div>
      <p>
        The link will display additional earthquake information. The information may include effects such as the numbers of injuries and houses destroyed, Modified Mercalli Intensity, references and comments.
      </p>
    </div>
  ),
};
